module.exports = __webpack_public_path__ + "img/negativemarking.bfd08ee7.png";